/* tslint:disable */
/* eslint-disable */
/**
 * CrateHackers API
 * This is the thing that does data stuff.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the CreateTutorialVideoDto interface.
 */
export function instanceOfCreateTutorialVideoDto(value) {
    if (!('videoId' in value) || value['videoId'] === undefined)
        return false;
    if (!('link' in value) || value['link'] === undefined)
        return false;
    if (!('imgAlt' in value) || value['imgAlt'] === undefined)
        return false;
    return true;
}
export function CreateTutorialVideoDtoFromJSON(json) {
    return CreateTutorialVideoDtoFromJSONTyped(json, false);
}
export function CreateTutorialVideoDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'videoId': json['videoId'],
        'link': json['link'],
        'imgAlt': json['imgAlt'],
        'displayOrder': json['displayOrder'] == null ? undefined : json['displayOrder'],
        'active': json['active'] == null ? undefined : json['active'],
    };
}
export function CreateTutorialVideoDtoToJSON(json) {
    return CreateTutorialVideoDtoToJSONTyped(json, false);
}
export function CreateTutorialVideoDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'videoId': value['videoId'],
        'link': value['link'],
        'imgAlt': value['imgAlt'],
        'displayOrder': value['displayOrder'],
        'active': value['active'],
    };
}
